import React from 'react';
import { Card, SageClassnames, Link } from '@kajabi/sage-react';
import PromptSuggestions from 'common/components/CopyMagic/generators/ConversationAssistant/components/PromptSuggestions';
import useGeneratorTrackingCallback from 'common/components/CopyMagic/hooks/useGeneratorTrackingCallback';

type Props = {
  last: boolean;
};

const GreetingFirst = ({ last }: Props) => {
  const trackWelcomeCardLinkClicked = useGeneratorTrackingCallback(
    'useTrackWelcomeCardLinkClicked',
  );

  if (!last) {
    return null;
  }

  const trackClick = (link: string) => {
    trackWelcomeCardLinkClicked({ link });
  };

  return (
    <>
      <Card
        className="copy-magic-conversation-assistant-message copy-magic-conversation-assistant-message--greeting-first"
        compact
        data-testid="message-greeting-first"
      >
        <p className={SageClassnames.TYPE.BODY_SMALL_MED}>
          <span role="img" aria-label="wave">
            👋
          </span>
          &nbsp; Meet Ama -- your new virtual assistant! If you&apos;re feeling unsure about where
          to start, here are three tips to help you:
        </p>
        <Card compact>
          <p className={SageClassnames.TYPE.BODY_SMALL_MED}>
            <strong>1. Start with small tasks:</strong>&nbsp; Begin by generating short sentences or
            paragraphs, then work your way up to more complex tasks.
          </p>
          <p className={SageClassnames.TYPE.BODY_SMALL_MED}>
            <strong>2. Explore the tool:</strong>&nbsp; Take some time to familiarize yourself with
            my features. Look for&nbsp;
            <Link
              href=" https://help.kajabi.com/hc/en-us/articles/16776393972379"
              target="_blank"
              onClick={() => trackClick('Help Center')}
              className={[
                SageClassnames.TYPE.BODY_SMALL_MED,
                SageClassnames.TYPE_COLORS.GREY_700,
              ].join(' ')}
              style={Link.COLORS.SECONDARY}
            >
              tutorials and guides
            </Link>
            &nbsp;to help you out.
          </p>
          <p className={SageClassnames.TYPE.BODY_SMALL_MED}>
            <strong>3. Customize the output:</strong>&nbsp; Give specific instructions or feedback
            to help me learn your preferences and produce more accurate content.
          </p>
        </Card>
        <p className={SageClassnames.TYPE.BODY_SMALL_MED}>
          Hope these tips help! Don&apos;t hesitate to ask me any questions you may have. Good luck
          and happy creating!
          <span role="img" aria-label="party">
            🎉
          </span>
        </p>
        <p
          className={[
            SageClassnames.TYPE.BODY_XSMALL_MED,
            SageClassnames.TYPE_COLORS.GREY_700,
          ].join(' ')}
        >
          By using this tool, you are agreeing to our&nbsp;
          <Link
            href="https://kajabi.com/policies/ai-terms"
            target="_blank"
            onClick={() => trackClick('ToS')}
            removeUnderline
            className={[
              SageClassnames.TYPE.BODY_XSMALL_MED,
              SageClassnames.TYPE_COLORS.GREY_700,
            ].join(' ')}
            style={Link.COLORS.SECONDARY}
          >
            Terms of Service
          </Link>
          &nbsp;and&nbsp;
          <Link
            href="https://legal.kajabi.com/policies/privacy"
            target="_blank"
            onClick={() => trackClick('Privacy')}
            removeUnderline
            className={[
              SageClassnames.TYPE.BODY_XSMALL_MED,
              SageClassnames.TYPE_COLORS.GREY_700,
            ].join(' ')}
            style={Link.COLORS.SECONDARY}
          >
            Privacy Notice
          </Link>
          .
        </p>
      </Card>
      <PromptSuggestions />
    </>
  );
};

export default GreetingFirst;
